import { useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../config/api';

const ChatbotIdentifier = () => {
  useEffect(() => {
    const identifyUser = async () => {
      try {
        let userId = null;
        let role = null;

        const adminId = localStorage.getItem('adminId') || sessionStorage.getItem('adminId');
        const adminToken = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
        
        const internToken = localStorage.getItem('internToken');
        const internDataStr = localStorage.getItem('internData');
        
        const volunteerId = localStorage.getItem('userId') || sessionStorage.getItem('userId');

        if (adminId && adminToken) {
          userId = adminId;
          role = 'admin';
        } else if (internToken && internDataStr) {
          try {
            const internData = JSON.parse(internDataStr);
            userId = internData.id;
            role = 'intern';
          } catch (e) {
            console.error('Error parsing internData', e);
          }
        } else if (volunteerId) {
          userId = volunteerId;
          role = 'volunteer';
        }

        if (!userId) {
          return;
        }

        const cacheKey = `chatbase_token_${userId}`;
        let chatbotToken = sessionStorage.getItem(cacheKey);

        if (!chatbotToken) {
          const response = await axios.get(`${API_BASE_URL}/api/auth/chatbot-token`, {
            params: { userId, role }
          });
          if (response.data && response.data.token) {
            chatbotToken = response.data.token;
            sessionStorage.setItem(cacheKey, chatbotToken);
          }
        }

        if (chatbotToken && window.chatbase) {
          window.chatbase('identify', { token: chatbotToken });
          console.log(`Successfully identified chatbot user: ${role} (${userId})`);
        }
      } catch (error) {
        console.error('Failed to identify chatbot user:', error);
      }
    };

    identifyUser();
  }, []);

  return null;
};

export default ChatbotIdentifier;
